module.exports = __webpack_public_path__ + "img/blokk.d647c3af.png";